export default __webpack_public_path__ + "static/media/T33.022f08cf.JPG";